import { useV2UpdateServiceAccountCredentialMutation } from "@generated";

interface UpdateInput {
  userId: string;
  credentialId: string;
  name: string;
  redirectUri?: string;
}

const useUpdateClientCredential = () => {
  const [trigger, { isLoading }] =
    useV2UpdateServiceAccountCredentialMutation();

  const updateCredential = async (input: UpdateInput): Promise<void> => {
    await trigger({
      userId: input.userId,
      id: input.credentialId,
      body: {
        data: {
          id: input.credentialId,
          type: "service-account-credentials",
          attributes: {
            name: input.name,
            "redirect-uri": input.redirectUri ?? "",
          },
        },
      },
    }).unwrap();
  };

  return { updateCredential, isUpdating: isLoading };
};

export default useUpdateClientCredential;
